var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmforaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1476.38 542.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.11,
    y1: 261.11,
    x2: 952.84,
    y2: 244.22,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36b56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 797.96,
    y1: 286.97,
    x2: 1426.03,
    y2: 156.34,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d56555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1058.45,
    y1: 215.95,
    x2: 1461.49,
    y2: 238.6,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef775e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e3221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 79.68,
    y1: 168.3,
    x2: 84.17,
    y2: 126.61,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 395.33,
    y1: 279.86,
    x2: 5.5,
    y2: 286.9,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c85b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a84c40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 339.89,
    y1: 320.47,
    x2: 1175.07,
    y2: 305.27,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb725a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab4e41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1020.71,
    y1: 229.6,
    x2: 1279.03,
    y2: 175.47,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee755a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1624f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1339.13,
    y1: 191.06,
    x2: 1476.61,
    y2: 194.02,
    gradientTransform: "translate(0 384.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60a27"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M954.52,47.68c-13.73,78.46-119.26,113.88-255.14,129.57C435.99,207.68,58.51,163.97,13.44,216.32c45.08-62.11,204.74-74.52,380.76-79.83h.77c237.28-7.26,504.03-1.86,559.52-88.83l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1475.16,123.92c-229.67,58.18-429.04-117.64-774.04-88.96-86.67,7.21-362.58,103.15-362.58,103.15,67.78-41.38,305.55-119.87,361.38-126.59,50.18-6.04,244.3-35.32,475.37,32.04h.11c20.02,5.87,40.3,12.41,60.81,19.8,148.34,53.3,238.95,60.56,238.95,60.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1475.16,124.68c-89.94,100.62-307.02,60.39-490.14,53.32-57.07-2.24-110.81-1.29-156.39,8.17,165.05-75.95,343.76-52.48,475.34-42.38h.06c77.62,5.93,138.82,7.31,171.13-19.14v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.77,213.32c-14.74,40.87-66.36,40.92-108.28,40.13-25.73-.48-47.85-1.27-55.49,6.88,10.11-39.25,71.42-49.3,116.84-50.06,21.74-.36,39.85,1.41,46.93,3.08v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M954.52,47.68c-13.73,78.23-119.31,113.54-255.25,129.18-106.88,4.99-147.5-44.45-304.5-40.62,237.38-7.25,504.24-1.87,559.75-88.58v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1175.73,43.56c-145.97-22.79-273.02-42.95-474.42-8.62-86.71,7.21-362.77,103.16-362.77,103.16,67.83-41.37,305.72-119.87,361.58-126.59,50.21-6.04,244.43-35.33,475.6,32.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1304.06,143.47c-109.47-1.97-141.69,37.27-319.01,34.09v.06c-57.08-2.23-110.83-1.28-156.41,8.15,165.08-75.81,343.82-52.39,475.43-42.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1339.5,210.46c93.9-11.5,133.95-51.58,133.95-51.58,11.52,47.7-6.48,85.94-133.95,51.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1225.38,538.62l150.05-252.97h58.14l42.82,252.97h-53.03l-11.39-60.89h-93.1l-36.14,60.89h-57.35ZM1335.75,436.88h77.39l-17.29-101.74-60.1,101.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.44,538.62l53.42-252.97h121.38c26.71,0,45.83,7.73,57.35,23.18,11.78,15.19,14.8,35.75,9.03,61.67-3.4,17.02-10.74,31.82-22,44.39-11,12.57-25.4,21.34-43.21,26.32,3.4,3.4,5.89,7.07,7.46,11,1.83,3.93,3.4,9.16,4.71,15.71l15.71,70.71h-54.99l-15.72-67.96c-1.31-5.76-3.27-9.82-5.89-12.18-2.62-2.36-7.6-3.53-14.93-3.53h-41.64l-17.68,83.67h-53.03ZM1088.58,410.96h54.6c13.88,0,25.4-3.01,34.57-9.03,9.16-6.29,15.19-16.76,18.07-31.43,3.14-14.14,2.49-24.49-1.96-31.03-4.19-6.55-14.27-9.82-30.25-9.82h-57.74l-17.28,81.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.32,542.55c-38.76,0-66.65-10.6-83.67-31.82-17.02-21.48-20.95-53.95-11.78-97.41,9.95-46.35,26.84-79.87,50.67-100.56,24.1-20.69,57.61-31.03,100.56-31.03,39.8,0,67.96,10.34,84.46,31.03,16.76,20.69,20.16,54.21,10.21,100.56-9.17,43.47-25.8,75.94-49.89,97.41-24.09,21.21-57.61,31.82-100.56,31.82ZM857.14,497.38c23.83,0,42.68-6.81,56.56-20.43,13.88-13.88,23.96-35.09,30.25-63.63,4.71-21.74,6.29-38.89,4.71-51.46-1.31-12.57-6.42-21.47-15.32-26.71-8.91-5.5-22.26-8.25-40.07-8.25-23.83,0-42.82,6.55-56.96,19.64-13.88,12.83-24.09,35.09-30.64,66.78-6.02,29.59-5.5,51.06,1.57,64.42,7.34,13.09,23.96,19.64,49.89,19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65,538.62l53.42-252.97h51.46l42.03,152.02,106.45-152.02h55l-53.42,252.97h-53.03l34.96-164.59-84.85,120.99h-30.64l-33.39-120.99-34.96,164.59h-53.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,538.62l53.42-252.97h181.48l-8.64,41.24H97.81l-13.75,64.81h113.92l-8.64,40.85h-113.92l-13.75,65.2h128.45l-8.64,40.86H0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.29 497.77 708.76 497.77 708.29 499.99 708.29 497.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "616.45 326.9 602.7 391.71 716.61 391.71 707.97 432.56 594.06 432.56 585.95 471 585.27 474.26 580.31 497.77 580.34 497.77 571.79 538.63 518.64 538.63 572.06 285.65 753.54 285.65 744.9 326.9 616.45 326.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmforaLogo);
export default __webpack_public_path__ + "static/media/emfora-logo.a45e2e9c10deb9854b93243858a6f188.svg";
export { ForwardRef as ReactComponent };